let Artists = [
  {
    name: "Marko Kostic",
    url: "marko",
    profileimg: "./imgs/artists/1.webp",
    position: "Owner, Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist1/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist1/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist1/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist1/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist1/5.webp" },
    ],
  },
  {
    name: "Savo Ostojic",
    url: "savoo",
    profileimg: "./imgs/artists/1.webp",
    position: "Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist2/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist2/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist2/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist2/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist2/5.webp" },
    ],
  },
  {
    name: "Ivan Maric",
    url: "ica",
    profileimg: "./imgs/artists/1.webp",
    position: "Tattoo Artist",
    portfolioLinks: [
      { title: "Project 1", url: "./imgs/portfolio/artist3/1.webp" },
      { title: "Project 2", url: "./imgs/portfolio/artist3/2.webp" },
      { title: "Project 3", url: "./imgs/portfolio/artist3/3.webp" },
      { title: "Project 4", url: "./imgs/portfolio/artist3/4.webp" },
      { title: "Project 5", url: "./imgs/portfolio/artist3/5.webp" },
    ],
  },
];

export default Artists;
